module.exports = __webpack_public_path__ + "img/ocpOesmv.2ce54fc1.svg";